export default {
	loading: "Cargando agenda...",
	unavailable: "Agenda no disponible",
	unavailableHint:
		"Este enlace puede haber expirado o el templo desactivó la agenda.",
	empty: "Ningún ritual publicado por el momento.",
	upcoming: "Próximos rituales",
	tabs: {
		calendar: "Calendario",
		info: "Más información",
	},
	info: {
		about: "Sobre la casa",
		address: "Dirección",
		contact: "Contacto",
		phone: "Teléfono",
		whatsapp: "WhatsApp",
		email: "Correo electrónico",
		social: "Redes sociales",
	},
	reserve: "Reservar lugar",
	full: "Completo",
	dialog: {
		title: "Reservar lugar",
		subtitle: "Completa tus datos para reservar en este ritual.",
		name: "Tu nombre",
		phone: "Teléfono",
		email: "Correo electrónico",
		notes: "Observación (opcional)",
		photo: {
			label: "Foto",
			capture: "Tomar foto",
			retake: "Tomar otra",
		},
		consent: "Autorizo al templo a usar mis datos de contacto para esta reserva.",
		consentWithPhoto:
			"Autorizo al templo a usar mis datos de contacto y la foto tomada ahora para esta reserva.",
		submit: "Enviar reserva",
		cancel: "Cancelar",
	},
	validation: {
		nameRequired: "Ingresa tu nombre",
		phoneRequired: "Ingresa tu teléfono",
		emailRequired: "Ingresa tu correo",
		emailInvalid: "Correo inválido",
		consentRequired: "Debes autorizar para reservar",
		photoRequired: "Toma una foto para completar la reserva",
	},
	success: {
		title: "¡Reserva recibida!",
		message: "Recibimos tu reserva. El templo la revisará y se pondrá en contacto.",
		close: "Cerrar",
	},
	error: "No pudimos enviar tu reserva. Inténtalo de nuevo.",
	poweredBy: "Agenda por ORI",
	tracking: {
		title: "Tu reserva",
		statusPendingConfirmation: "Confirma tu reserva",
		statusPendingReview: "Esperando revisión del templo",
		statusApproved: "Reserva confirmada",
		statusRejected: "Reserva rechazada",
		statusCancelled: "Reserva cancelada",
		confirmHint: "Haz clic abajo para confirmar tu asistencia a este ritual.",
		reviewHint: "Recibimos tu confirmación. El templo la revisará y se pondrá en contacto.",
		approvedHint: "¡Listo! Tu asistencia está confirmada.",
		confirm: "Confirmar reserva",
		cancel: "Cancelar reserva",
		confirmed: "¡Reserva confirmada!",
		cancelled: "Reserva cancelada.",
		error: "No se pudo completar. Inténtalo de nuevo.",
		notFound: "Reserva no encontrada.",
	},
};
